import React from "react";
import { Link } from "react-router-dom";

export default function ManagerSidebar() {
  return (
    <div className="w-64 bg-white h-screen shadow-md p-4">
      <h2 className="text-xl font-bold mb-6">Manager Panel</h2>

      <nav className="flex flex-col gap-3">
        <Link to="/manager/dashboard" className="hover:text-blue-600">
          Dashboard
        </Link>

        <Link to="/manager/team" className="hover:text-blue-600">
          Team Members
        </Link>

        <Link to="/manager/leave-requests" className="hover:text-blue-600">
          Leave Requests
        </Link>

        <Link to="/manager/attendance" className="hover:text-blue-600">
          Team Attendance
        </Link>

        <Link to="/manager/timesheets" className="hover:text-blue-600">
          Timesheet Approvals
        </Link>

        <Link to="/manager/reports" className="hover:text-blue-600">
          Reports
        </Link>

        <Link to="/manager/announcements" className="hover:text-blue-600">
          Announcements
        </Link>
      </nav>
    </div>
  );
}
